import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
import { useLanguage } from "@/hooks/useLanguage";

const CaseStudyStats = () => {
  const { ref, isVisible } = useScrollAnimation();
  const { tObject } = useLanguage();
  const stats = tObject<Array<{ value: string; label: string }>>("caseStudyBgeh.stats");
  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="py-12 md:py-16 bg-primary">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            {stats.map((stat, index) => (
              <div key={index} className={cn("text-center transition-all duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{ transitionDelay: isVisible ? `${index * 100}ms` : "0ms" }}>
                <div className="text-4xl md:text-5xl font-extrabold text-chathero-mint mb-2">{stat.value}</div>
                <div className="text-sm md:text-base text-primary-foreground/80">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
export default CaseStudyStats;
